import Vue from "vue";
import Router from "vue-router";
import { Authenticate } from "./middlewares/authenticate";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "base",
            redirect: "/login"
        },
        {
            path: "/login",
            name: "login",
            meta:{
                title : ''
            },
            component: () => import(/* webpackChunkName: "login" */"@/views/Login.vue")
        },
        {
            path: '/logout',
            name: 'logout',
            meta : {
                title : 'Saindo do sistema'
            },
            component: () => import(/* webpackChunkName: "logout" */"@/views/Logout.vue")
        },
        {
            path: "/dashboard",
            name: "dashboard",
            meta: {
                title: "Dashboard",
            },
            component: () => import(/* webpackChunkName: "dashboard" */"@/views/Dashboard.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: '/profile',
            name: 'profile.edit',
            meta: {
                title: "Editar Perfil do Usuário",
            },
            component: _ => import('@/views/Users/Profile.vue'),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/modules",
            name: "modules.index",
            meta: {
                title: "Módulos"
            },
            component: () => import(/* webpackChunkName: "modules_index" */"@/views/Modules/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/modules/create",
            name: "modules.create",
            meta: {
                title: "Módulos"
            },
            component: () => import(/* webpackChunkName: "modules_create" */"@/views/Modules/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/modules/:id",
            name: "modules.edit",
            meta: {
                title: "Módulos"
            },
            component: () => import(/* webpackChunkName: "modules_edit" */"@/views/Modules/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/functionalities",
            name: "functionalities.index",
            meta: {
                title: "Funcionalidades"
            },
            component: () => import(/* webpackChunkName: "functionalities_index" */"@/views/Functionalities/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/functionalities/create",
            name: "functionalities.create",
            meta: {
                title: "Funcionalidades"
            },
            component: () => import(/* webpackChunkName: "functionalities_create" */"@/views/Functionalities/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/functionalities/:id",
            name: "functionalities.edit",
            meta: {
                title: "Funcionalidades"
            },
            component: () => import(/* webpackChunkName: "functionalities_edit" */"@/views/Functionalities/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/profiles",
            name: "profiles.index",
            meta: {
                title: "Perfis"
            },
            component: () => import(/* webpackChunkName: "profiles_index" */"@/views/Profiles/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/profiles/create",
            name: "profiles.create",
            meta: {
                title: "Perfis"
            },
            component: () => import(/* webpackChunkName: "profiles_create" */"@/views/Profiles/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/profiles/:id",
            name: "profiles.edit",
            meta: {
                title: "Perfis"
            },
            component: () => import(/* webpackChunkName: "profiles_edit" */"@/views/Profiles/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/profiles/:id/administrators",
            name: "profiles.administrators.index",
            meta: {
                title: "Comissões do Perfil"
            },
            component: () => import(/* webpackChunkName: "comissions_index" */"@/views/Comissions/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            },
            children: [
                {
                    path: ":administrator/comissions",
                    name: "profiles.administrators.comissions",
                    meta: {
                        title: "Comissões do Perfil"
                    },
                    component:() => import(/* webpackChunkName: "comissions_administrator" */"@/views/Comissions/Administrator.vue"),
                },
            ]
        },
        {
            path: "/contracts",
            name: "contracts.index",
            meta: {
                title: "Formalização"
            },
            component: () => import(/* webpackChunkName: "contracts_index" */"@/views/Contracts/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            },
            children: [
                {
                    path: '/contracts/:id/edit',
                    name: 'contracts.edit',
                    meta: {
                        title: "Formalização",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "contracts_edit" */`@/views/Contracts/Edit.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated(to);
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
                {
                    path: '/contracts/:id/documents',
                    name: 'contracts.documents',
                    meta: {
                        title: "Formalização",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "contracts_documents" */`@/views/Contracts/Documents.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated({name: "contracts.index"});
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
                {
                    path: '/contracts/:id/history',
                    name: 'contracts.history',
                    meta: {
                        title: "Formalização",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "contracts_history" */`@/views/Contracts/History.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated({name: "contracts.index"});
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
            ]
        },
        {
            path: "/link-customers-to-contracts",
            name: "link-customers-to-contracts.index",
            meta: {
                title: "Vincular Clientes a Contratos"
            },
            component: () => import(/* webpackChunkName: "link_customers_to_contracts" */"@/views/LinkCustomersToContracts/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            },
        },
        {
            path: "/contract-status",
            name: "contract-status.index",
            meta: {
                title: "Status da Formalização"
            },
            component: () => import(/* webpackChunkName: "contract_status_index" */"@/views/ContractStatus/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/contract-status/create",
            name: "contract-status.create",
            meta: {
                title: "Status da Formalização"
            },
            component: () => import(/* webpackChunkName: "contract_status_create" */"@/views/ContractStatus/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/contract-status/:id",
            name: "contract-status.edit",
            meta: {
                title: "Status da Formalização"
            },
            component: () => import(/* webpackChunkName: "contract_status_edit" */"@/views/ContractStatus/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/after_sales",
            name: "after_sales.index",
            meta: {
                title: "Pós Venda"
            },
            component: () => import(/* webpackChunkName: "after_sales_index" */"@/views/AfterSales/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            },
            children: [
                {
                    path: '/after_sales/:id/edit',
                    name: 'after_sales.edit',
                    meta: {
                        title: "Pós Venda",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "after_sales_edit" */`@/views/AfterSales/Edit.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated(to);
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
                {
                    path: '/after_sales/:id/history',
                    name: 'after_sales.history',
                    meta: {
                        title: "Pós Venda",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "after_sales_history" */`@/views/AfterSales/History.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated({name: "after_sales.index"});
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
            ]
        },
        {
            path: "/after-sale-status",
            name: "after-sale-status.index",
            meta: {
                title: "Status da Pós Venda"
            },
            component: () => import(/* webpackChunkName: "after_sale_status_index" */"@/views/AfterSaleStatus/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/after-sale-status/create",
            name: "after-sale-status.create",
            meta: {
                title: "Status da Pós Venda"
            },
            component: () => import(/* webpackChunkName: "after_sale_status_create" */"@/views/AfterSaleStatus/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/after-sale-status/:id",
            name: "after-sale-status.edit",
            meta: {
                title: "Status da Pós Venda"
            },
            component: () => import(/* webpackChunkName: "after_sale_status_edit" */"@/views/AfterSaleStatus/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/users",
            name: "users.index",
            meta: {
                title: "Usuários"
            },
            component: () => import(/* webpackChunkName: "users_index" */"@/views/Users/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/users/create",
            name: "users.create",
            meta: {
                title: "Usuários"
            },
            component: () => import(/* webpackChunkName: "users_create" */"@/views/Users/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/users/:id",
            name: "users.edit",
            meta: {
                title: "Usuários"
            },
            component: () => import(/* webpackChunkName: "users_edit" */"@/views/Users/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/audits",
            name: "audits.index",
            meta: {
                title: "Auditorias"
            },
            component: () => import(/* webpackChunkName: "audits_index" */"@/views/Audits/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/configurations",
            name: "configurations.index",
            meta: {
                title: "Configurações"
            },
            component: () => import(/* webpackChunkName: "configurations_index" */"@/views/Configurations/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/branches",
            name: "branches.index",
            meta: {
                title: "Filiais"
            },
            component: () => import(/* webpackChunkName: "branches_index" */"@/views/Branches/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/branches/create",
            name: "branches.create",
            meta: {
                title: "Filiais"
            },
            component: () => import(/* webpackChunkName: "branches_create" */"@/views/Branches/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/branches/:id",
            name: "branches.edit",
            meta: {
                title: "Filiais"
            },
            component: () => import(/* webpackChunkName: "branches_edit" */"@/views/Branches/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/teams",
            name: "teams.index",
            meta: {
                title: "Equipes"
            },
            component: () => import(/* webpackChunkName: "teams_index" */"@/views/Teams/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/teams/create",
            name: "teams.create",
            meta: {
                title: "Equipes"
            },
            component: () => import(/* webpackChunkName: "teams_create" */"@/views/Teams/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/teams/:id",
            name: "teams.edit",
            meta: {
                title: "Equipes"
            },
            component: () => import(/* webpackChunkName: "teams_edit" */"@/views/Teams/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/charges",
            name: "charges.index",
            meta: {
                title: "Cobranças",
                showModal: false
            },
            component: () => import(/* webpackChunkName: "Charges_index" */"@/views/Charges/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            },
            children: [
                {
                    path: '/charges/:id/contacts',
                    name: 'charges.contacts.index',
                    meta: {
                        title: "Contato de cobrança",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "Charges_contacts" */`@/views/Charges/Contacts.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated(to);
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
                {
                    path: '/charges/:id/send_slips',
                    name: 'charges.send_slips.index',
                    meta: {
                        title: "Enviar boleto",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "Charges_send_slips" */`@/views/Charges/SendSlips.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated(to);
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
                {
                    path: '/charges/:id/salesman_evaluations',
                    name: 'charges.salesman_evaluations.index',
                    meta: {
                        title: "Avaliar vendedor",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "Charges_salesman_evaluations" */`@/views/Charges/SalesmanEvaluations.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated(to);
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
                {
                    path: '/charges/:id/evaluation',
                    name: 'charges.evaluation.index',
                    meta: {
                        title: "Vendedor avaliado",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: false
                    },
                    components: {
                        // modal: () => import(/* webpackChunkName: "Charges_evaluation" */`@/views/Charges/Evaluation.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated(to);
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
                {
                    path: '/charges/:id/show',
                    name: 'charges.show',
                    meta: {
                        title: "Visualizar dados da proposta",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "Charges_show" */`@/views/Charges/Show.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated(to);
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                }
            ]
        },
        {
            path: "/proposals",
            name: "proposals.index",
            meta: {
                title: "Propostas"
            },
            component: () => import(/* webpackChunkName: "proposals_index" */"@/views/Proposals/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/proposals/create",
            name: "proposals.create",
            meta: {
                title: "Propostas"
            },
            component: () => import(/* webpackChunkName: "proposals_create" */"@/views/Proposals/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/proposals/:id",
            name: "proposals.show",
            meta: {
                title: "Propostas"
            },
            component: () => import(/* webpackChunkName: "proposals_show" */"@/views/Proposals/Show.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            },
            children: [
                {
                    path : "duplicate",
                    name : "proposals.duplicate",
                    meta: {
                        title : "Propostas"
                    },
                    component:() => import('@/views/Proposals/Duplicate.vue')
                },
                {
                    path: "invoice",
                    name: "proposals.invoice",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import("@/views/Proposals/Invoice.vue")
                },
                {
                    path: "cancel",
                    name: "proposals.cancel",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_cancel" */"@/views/Proposals/Cancel.vue")
                },
                {
                    path: "contemplate",
                    name: "proposals.contemplate",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_contemplate" */"@/views/Proposals/Contemplate.vue")
                },
                {
                    path: "in-default",
                    name: "proposals.in_default",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_in_default" */"@/views/Proposals/InDefault.vue")
                },
                {
                    path: "transf-client",
                    name: "proposals.transf-client",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_transf_client" */"@/views/Proposals/TransfClient.vue")
                },
                {
                    path: "transf-salesman",
                    name: "proposals.transf-salesman",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_transf_salesman" */"@/views/Proposals/TransfSalesman.vue")
                },
                {
                    path: "pay-installment/:installment",
                    name: "proposals.pay-installment",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_pay_installment" */"@/views/Proposals/PayInstallment.vue")
                },
                {
                    path: "reverse-pay-installment/:installment",
                    name: "proposals.reverse-pay-installment",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_reverse_pay_installment" */"@/views/Proposals/RervesePayInstallment.vue")
                },
                {
                    path: "edit-parcel/:installment",
                    name: "proposals.edit-parcel",
                    meta: {
                        title: "Propostas"
                    },
                    component:() => import(/* webpackChunkName: "proposals_edit_parcel" */"@/views/Proposals/EditParcel.vue")
                },
            ]
        },
        {
            path: "/proposals/:id/edit",
            name: "proposals.edit",
            meta: {
                title: "Propostas"
            },
            component: () => import(/* webpackChunkName: "proposals_edit" */"@/views/Proposals/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/administrators",
            name: "administrators.index",
            meta: {
                title: "Administradoras"
            },
            component: () => import(/* webpackChunkName: "administrator_index" */"@/views/Administrators/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/administrators/create",
            name: "administrators.create",
            meta: {
                title: "Administradoras"
            },
            component: () => import(/* webpackChunkName: "administrator_create" */"@/views/Administrators/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/administrators/:id",
            name: "administrators.edit",
            meta: {
                title: "Administradoras"
            },
            component: () => import(/* webpackChunkName: "administrator_edit" */"@/views/Administrators/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/administrators/:administrator_id/plans",
            name: "administrators.plans.index",
            meta: {
                title: "Planos"
            },
            component: () => import(/* webpackChunkName: "administrators_plans_index" */"@/views/Plans/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/administrators/:administrator_id/plans/create",
            name: "administrators.plans.create",
            meta: {
                title: "Planos"
            },
            component: () => import(/* webpackChunkName: "administrators_plans_create" */"@/views/Plans/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/administrators/:administrator_id/plans/:id",
            name: "administrators.plans.edit",
            meta: {
                title: "Planos"
            },
            component: () => import(/* webpackChunkName: "administrators_plans_index" */"@/views/Plans/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/groups",
            name: "groups.index",
            meta: {
                title: "Grupos"
            },
            component: () => import(/* webpackChunkName: "groups_index" */"@/views/Groups/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/groups/create",
            name: "groups.create",
            meta: {
                title: "Grupos"
            },
            component: () => import(/* webpackChunkName: "groups_create" */"@/views/Groups/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/groups/:id",
            name: "groups.edit",
            meta: {
                title: "Grupos"
            },
            component: () => import(/* webpackChunkName: "groups_edit" */"@/views/Groups/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/manufacturers",
            name: "manufacturers.index",
            meta: {
                title: "Marca/Categoria"
            },
            component: () => import(/* webpackChunkName: "manufacturers_index" */"@/views/Manufacturers/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/manufacturers/create",
            name: "manufacturers.create",
            meta: {
                title: "Fabricantes"
            },
            component: () => import(/* webpackChunkName: "manufacturers_create" */"@/views/Manufacturers/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/manufacturers/:id",
            name: "manufacturers.edit",
            meta: {
                title: "Fabricantes"
            },
            component: () => import(/* webpackChunkName: "manufacturers_edit" */"@/views/Manufacturers/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/models",
            name: "models.index",
            meta: {
                title: "Modelos"
            },
            component: () => import(/* webpackChunkName: "models_index" */"@/views/Models/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/models/create",
            name: "models.create",
            meta: {
                title: "Modelos"
            },
            component: () => import(/* webpackChunkName: "models_create" */"@/views/Models/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/models/:id",
            name: "models.edit",
            meta: {
                title: "Modelos"
            },
            component: () => import(/* webpackChunkName: "models_edit" */"@/views/Models/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/fuels",
            name: "fuels.index",
            meta: {
                title: "Combustíveis"
            },
            component: () => import(/* webpackChunkName: "fuels_index" */"@/views/Fuels/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/fuels/create",
            name: "fuels.create",
            meta: {
                title: "Combustíveis"
            },
            component: () => import(/* webpackChunkName: "fuels_create" */"@/views/Fuels/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/fuels/:id",
            name: "fuels.edit",
            meta: {
                title: "Combustíveis"
            },
            component: () => import(/* webpackChunkName: "fuels_edit" */"@/views/Fuels/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/medias",
            name: "medias.index",
            meta: {
                title: "Mídias"
            },
            component: () => import(/* webpackChunkName: "medias_index" */"@/views/Medias/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/medias/create",
            name: "medias.create",
            meta: {
                title: "Mídias"
            },
            component: () => import(/* webpackChunkName: "medias_create" */"@/views/Medias/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/medias/:id",
            name: "medias.edit",
            meta: {
                title: "Mídias"
            },
            component: () => import(/* webpackChunkName: "medias_edit" */"@/views/Medias/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/type_of_payments",
            name: "type_of_payments.index",
            meta: {
                title: "Tipos de Pagamento"
            },
            component: () => import(/* webpackChunkName: "typeofpayments_index" */"@/views/TypeOfPayments/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/type_of_payments/create",
            name: "type_of_payments.create",
            meta: {
                title: "Tipos de Pagamento"
            },
            component: () => import(/* webpackChunkName: "typeofpayments_create" */"@/views/TypeOfPayments/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/type_of_payments/:id",
            name: "type_of_payments.edit",
            meta: {
                title: "Tipos de Pagamento"
            },
            component: () => import(/* webpackChunkName: "typeofpayments_edit" */"@/views/TypeOfPayments/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/config/messages",
            name: "config.messages.index",
            meta: {
                title: "Configurar mensagens automáticas"
            },
            component: () => import(/* webpackChunkName: "config.messages.index" */"@/views/Branches/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/commission-by-profiles",
            name: "reports.commission-by-profiles.index",
            meta: {
                title: "Relatório de Comissão por Perfil"
            },
            component: () => import(/* webpackChunkName: "reports_commission_by_profiles_index" */"@/views/Reports/CommissionByProfiles/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-commission-by-profiles",
            name: "reports.print-commission-by-profiles.index",
            meta: {
                title: "Relatório de Comissão por Perfil"
            },
            component: () => import(/* webpackChunkName: "reports_print_commission_by_profiles_index" */"@/views/Reports/CommissionByProfiles/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/analytical-commission-by-profiles",
            name: "reports.analytical-commission-by-profiles.index",
            meta: {
                title: "Relatório de Comissão Analítica por Perfil"
            },
            component: () => import(/* webpackChunkName: "reports_analytical_commission_by_profiles_index" */"@/views/Reports/AnalyticalCommissionByProfiles/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/store-commission",
            name: "reports.store-commission.index",
            meta: {
                title: "Relatório de Comissão Por Loja"
            },
            component: () => import(/* webpackChunkName: "reports_store_commission_index" */"@/views/Reports/StoreCommission/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-store-commission",
            name: "reports.print-store-commission.index",
            meta: {
                title: "Relatório de Comissão Por Loja"
            },
            component: () => import(/* webpackChunkName: "reports_print_store_commission_index" */"@/views/Reports/StoreCommission/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/production-rating",
            name: "reports.production-rating.index",
            meta: {
                title: "Relatório - Ranking de Produção"
            },
            component: () => import(/* webpackChunkName: "reports_store_commission_index" */"@/views/Reports/ProductionRating/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-production-rating",
            name: "reports.print-production-rating.index",
            meta: {
                title: "Relatório - Ranking de Produção"
            },
            component: () => import(/* webpackChunkName: "reports_print_store_commission_index" */"@/views/Reports/ProductionRating/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-analytical-commission-by-profiles",
            name: "reports.print-analytical-commission-by-profiles.index",
            meta: {
                title: "Relatório de Comissão por Perfil"
            },
            component: () => import(/* webpackChunkName: "reports_print_analytical_commission_by_profiles_index" */"@/views/Reports/AnalyticalCommissionByProfiles/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/commission-of-production-by-proposal-types", 
            name: "reports.commission-of-production-by-proposal-types.index",
            meta: {
                title: "Relatório de Produção por Tipos de Propostas", 
            },
            component: () => import(/* webpackChunkName: "reports_commission_of_production_by_proposal_types_index" */"@/views/Reports/CommissionOfProductionByProposalTypes/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-commission-of-production-by-proposal-types", 
            name: "reports.print-commission-of-production-by-proposal-types.index",
            meta: {
                title: "Relatório de Produção por Tipos de Propostas", 
            },
            component: () => import(/* webpackChunkName: "reports_print_commission_of_production_by_proposal_types_index" */"@/views/Reports/CommissionOfProductionByProposalTypes/Print.vue"), 
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/commission-of-months", 
            name: "reports.commission-of-months.index",
            meta: {
                title: "Relatório de Produção Mensal", 
            },
            component: () => import(/* webpackChunkName: "reports_commission_of_months_index" */"@/views/Reports/CommissionOfProductionMonth/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-commission-of-months", 
            name: "reports.print-commission-of-months.index",
            meta: {
                title: "Relatório de Produção Mensal", 
            },
            component: () => import(/* webpackChunkName: "reports_print_commission_of_months_index" */"@/views/Reports/CommissionOfProductionMonth/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/surplus-per-installments",
            name: "reports.surplus-per-installments.index",
            meta: {
                title: "Relatório de Comissão por excedente de parcelas"
            },
            component: () => import(/* webpackChunkName: "reports_surplus_per_installmentss_index" */"@/views/Reports/SurplusPerInstallments/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-surplus-per-installments",
            name: "reports.print-surplus-per-installments.index",
            meta: {
                title: "Relatório de Comissão por excedente de parcelas"
            },
            component: () => import(/* webpackChunkName: "reports_print_surplus_per_installments_index" */"@/views/Reports/SurplusPerInstallments/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/contemplation",
            name: "reports.contemplation.index",
            meta: {
                title: "Relatório de Contemplação"
            },
            component: () => import(/* webpackChunkName: "reports_contemplation_index" */"@/views/Reports/Contemplation/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-contemplation",
            name: "reports.print-contemplation.index",
            meta: {
                title: "Relatório de Contemplação"
            },
            component: () => import(/* webpackChunkName: "reports_print_contemplation_index" */"@/views/Reports/Contemplation/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/billing",
            name: "reports.billing.index",
            meta: {
                title: "Relatório de Faturamento"
            },
            component: () => import(/* webpackChunkName: "reports_billing_index" */"@/views/Reports/Billing/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-billing",
            name: "reports.print-billing.index",
            meta: {
                title: "Relatório de Faturamento"
            },
            component: () => import(/* webpackChunkName: "reports_print_billing_index" */"@/views/Reports/Billing/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/standard-imports",
            name: "standard-imports.index",
            meta: {
                title: "Importação Padrão",
            },
            component: () => import(/* webpackChunkName: "reports_standard_imports_index" */"@/views/StandardImport/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/download-bills",
            name: "download-bills.index",
            meta: {
                title: "Download de Boletos",
            },
            component: () => import(/* webpackChunkName: "download_bills_index" */"@/views/DownloadBills/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/leads/import",
            name: "leads.import.index",
            meta: {
                title: "Importar Leads"
            },
            component: () => import(/* webpackChunkName: "leads_import_index" */"@/views/Leads/Import.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/leads/supervise",
            name: "leads.supervise.index",
            meta: {
                title: "Supervisionar Leads"
            },
            component: () => import(/* webpackChunkName: "leads_supervise_index" */"@/views/Leads/Supervise.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            },
            children: [
                {
                    path : "share",
                    name : "leads.supervise.share",
                    meta: {
                        title : "Dividir Leads"
                    },
                    component:() => import('@/views/Leads/ShareLeads.vue')
                },
            ]
        },
        {
            path: "/leads/agenda",
            name: "leads.agenda.index",
            meta: {
                title: "Agenda de Leads"
            },
            component: () => import(/* webpackChunkName: "leads_agenda_index" */"@/views/Leads/Agenda.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/leads/agenda/create",
            name: "leads.agenda.create",
            meta: {
                title: "Criar Agendamento de Lead"
            },
            component: () => import(/* webpackChunkName: "leads_agenda_index" */"@/views/Leads/AgendaCreate.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/leads/status",
            name: "leads.status.index",
            meta: {
                title: "Status dos Leads"
            },
            component: () => import(/* webpackChunkName: "leads_status_index" */"@/views/Leads/Status.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/leads/status/create",
            name: "leads.status.create",
            meta: {
                title: "Status dos Leads"
            },
            component: () => import(/* webpackChunkName: "leads_status_create" */"@/views/Leads/StatusCreate.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/leads/status/edit/:id",
            name: "leads.status.edit",
            meta: {
                title: "Status dos Leads"
            },
            component: () => import(/* webpackChunkName: "leads_status_edit" */"@/views/Leads/StatusEdit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/leads/agenda/edit/:id",
            name: "leads.agenda.edit",
            meta: {
                title: "Lead"
            },
            component: () => import(/* webpackChunkName: "leads_edit" */"@/views/Leads/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/lead-conversion",
            name: "reports.lead-conversion.index",
            meta: {
                title: "Relatório de Taxa de Conversão de Leads",
            },
            component: () => import(/* webpackChunkName: "reports_lead_conversion_index" */"@/views/Reports/LeadConversion/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-lead-conversion",
            name: "reports.print-lead-conversion.index",
            meta: {
                title: "Relatório de Taxa de Conversão de Leads",
            },
            component: () => import(/* webpackChunkName: "reports_print_lead_conversion_index" */"@/views/Reports/LeadConversion/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/import-data-from-old-versions",
            name: "import-data-from-old-versions.index",
            meta: {
                title: "Importação Consyst 1.0",
            },
            component: () => import(/* webpackChunkName: "import-data-from-old-versions_index" */"@/views/ImportDataFromOldVersions/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/media-conversion",
            name: "reports.media-conversion.index",
            meta: {
                title: "Relatório de Conversão de Mídias",
            },
            component: () => import(/* webpackChunkName: "reports_print_lead_conversion_index" */"@/views/Reports/MediaConversion/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-media-conversion",
            name: "reports.print-media-conversion.index",
            meta: {
                title: "Relatório de Conversão de Mídias",
            },
            component: () => import(/* webpackChunkName: "reports_print_lead_conversion_index" */"@/views/Reports/MediaConversion/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/evaluations",
            name: "reports.evaluations.index",
            meta: {
                title: "Relatório Avaliação Vendedor",
            },
            component: () => import(/* webpackChunkName: "reports_print_lead_conversion_index" */"@/views/Reports/Evaluations/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-evaluations",
            name: "reports.print-evaluations.index",
            meta: {
                title: "Relatório Avaliação Vendedor",
            },
            component: () => import(/* webpackChunkName: "reports_print_lead_conversion_index" */"@/views/Reports/Evaluations/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },

        {
            path: "/reports/non-payment-montly",
            name: "reports.non-payment-montly.index",
            meta: {
                title: "Relatório de Inadimplência Mensal",
            },
            component: () => import(/* webpackChunkName: "reports_lead_conversion_index" */"@/views/Reports/NonPaymentMontly/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-non-payment-montly",
            name: "reports.print-non-payment-montly.index",
            meta: {
                title: "Relatório de Inadimplência Mensal",
            },
            component: () => import(/* webpackChunkName: "reports_print_lead_conversion_index" */"@/views/Reports/NonPaymentMontly/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/non-payment-cancellation",
            name: "reports.non-payment-cancellation.index",
            meta: {
                title: "Relatório de Inadimplência por Cancelamento",
            },
            component: () => import(/* webpackChunkName: "reports_print_non_payment_cancellation_index" */"@/views/Reports/NonPaymentCancellation/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-non-payment-cancellation",
            name: "reports.print-non-payment-cancellation.index",
            meta: {
                title: "Relatório de Inadimplência por Cancelamento",
            },
            component: () => import(/* webpackChunkName: "reports_print_non_payment_cancellation_index" */"@/views/Reports/NonPaymentCancellation/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },


        {
            path: "/reports/non-payment-delay",
            name: "reports.non-payment-delay.index",
            meta: {
                title: "Relatório de Inadimplência por Atraso",
            },
            component: () => import(/* webpackChunkName: "reports_print_non_payment_cancellation_index" */"@/views/Reports/NonPaymentDelay/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-non-payment-delay",
            name: "reports.print-non-payment-delay.index",
            meta: {
                title: "Relatório de Inadimplência por Atraso",
            },
            component: () => import(/* webpackChunkName: "reports_print_non_payment_cancellation_index" */"@/views/Reports/NonPaymentDelay/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/type-sales",
            name: "reports.type-sales.index",
            meta: {
                title: "Relatório de Tipos de Venda por Perfil",
            },
            component: () => import(/* webpackChunkName: "reports_type_sales_index" */"@/views/Reports/TypeSales/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-type-sales",
            name: "reports.print-type-sales.index",
            meta: {
                title: "Relatório de Tipos de Venda por Perfil",
            },
            component: () => import(/* webpackChunkName: "reports_type_sales_index" */"@/views/Reports/TypeSales/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/after-sales",
            name: "reports.after-sales.index",
            meta: {
                title: "Relatório de Pós Venda",
            },
            component: () => import(/* webpackChunkName: "reports_after_sales_index" */"@/views/Reports/AfterSales/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-after-sales",
            name: "reports.print-after-sales.index",
            meta: {
                title: "Relatório de Pós Venda",
            },
            children: [
                {
                    path: '/reports/print-after-sales/:id/history',
                    name: 'reports.print-after-sales.history',
                    meta: {
                        title: "Pós Venda",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "after_sales_history" */`@/views/AfterSales/History.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated({name: "after_sales.index"});
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
            ],
            component: () => import(/* webpackChunkName: "reports_after_sales_index" */"@/views/Reports/AfterSales/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/contracts",
            name: "reports.contracts.index",
            meta: {
                title: "Relatório de Formalização",
            },
            component: () => import(/* webpackChunkName: "reports_contracts_index" */"@/views/Reports/Contracts/Form.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/reports/print-contracts",
            name: "reports.print-contracts.index",
            meta: {
                title: "Relatório de Formalização",
            },
            children: [
                {
                    path: '/reports/print-contracts/:id/history',
                    name: 'reports.print-contracts.history',
                    meta: {
                        title: "Formalização",
                        public: false,
                        breadcrumb: false,
                        requiresAuth: true,
                        translatedTitle: false,
                        showModal: true
                    },
                    components: {
                        modal: () => import(/* webpackChunkName: "contracts_history" */`@/views/Contracts/History.vue`)
                    },
                    beforeEnter: async (to, from, next) => {
                        const authenticated = Authenticate.authenticated({name: "contracts.index"});
                        authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
                    }
                },
            ],
            component: () => import(/* webpackChunkName: "reports_contracts_index" */"@/views/Reports/Contracts/Print.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/integrations",
            name: "integrations.index",
            meta: {
                title: "Configuração das Integrações"
            },
            component: () => import(/* webpackChunkName: "integrations_index" */"@/views/Integrations/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/sync-contracts-and-after-sales",
            name: "sync-contracts-and-after-sales.index",
            meta: {
                title: "Sincronizar Formalização e Pós Vendas",
            },
            component: () => import(/* webpackChunkName: "sync_contracts_and_after_sales_index" */"@/views/SyncContractsAndAfterSales/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);

                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/pending-reasons",
            name: "pending-reasons.index",
            meta: {
                title: "Razões de Pendência"
            },
            component: () => import(/* webpackChunkName: "pending_reasons_index" */"@/views/PendingReasons/Index.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/pending-reasons/create",
            name: "pending-reasons.create",
            meta: {
                title: "Razões de Pendência"
            },
            component: () => import(/* webpackChunkName: "pending_reasons_create" */"@/views/PendingReasons/Create.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
        {
            path: "/pending-reasons/:id",
            name: "pending-reasons.edit",
            meta: {
                title: "Razões de Pendência"
            },
            component: () => import(/* webpackChunkName: "pending_reasons_edit" */"@/views/PendingReasons/Edit.vue"),
            beforeEnter: async (to, from, next) => {
                const authenticated = Authenticate.authenticated(to);
                
                authenticated.then((_result) => {if (_result) {next();} else {next({ path: from.fullPath });}});
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    if(document.getElementById("breadcrumb")){
        document.getElementById("breadcrumb").innerHTML = to.meta.title;
    }
    next();
});

export default router;
